import type { FunctionComponent } from 'react';

import { Logger } from '../../../logger/Logger';
import { ErrorBoundary } from '../../errorBoundary/ErrorBoundary';

import { CanvasMirror } from './canvasMirror/CanvasMirror';
import { StreamMirror } from './streamMirror/StreamMirror';

export interface VideoMirrorProps {
  videoElement: HTMLVideoElement;
}

declare global {
  interface HTMLVideoElement {
    captureStream: () => MediaStream;
    mozCaptureStream: () => MediaStream;
  }
}

export const IS_CAPTURE_STREAM_SUPPORTED =
  'captureStream' in HTMLVideoElement.prototype || 'mozCaptureStream' in HTMLVideoElement.prototype;

export const VideoMirror: FunctionComponent<VideoMirrorProps> = (props) => {
  return (
    <ErrorBoundary
      fallback={<></>}
      onError={(error, errorInfo) => {
        Logger.logFailure('videoMirror', {
          place: errorInfo?.componentStack ?? '',
        });
        Logger.logException(error);
      }}
    >
      {IS_CAPTURE_STREAM_SUPPORTED ? <StreamMirror {...props} /> : <CanvasMirror {...props} />}
    </ErrorBoundary>
  );
};
